import { get } from 'lodash/get'
import { handleError } from 'helper/rest'
import { clientPublic, clientPublicService } from 'helper/axios'
import { encodeId } from 'helper/sqids'
let resError = ''
export const getTree = async ({ token }) => {
  try {
    return await clientPublicService
      .post(
        `/core/management/company/tree`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

export const getBenefitTypeList = async ({ token, buId }) => {
  try {
    const encodedId = encodeId(buId)

    return await clientPublicService
      .get(`/core/management/benefit-type/${encodedId}/list`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

export const createBenefitType = async ({ token, payload }) => {
  try {
    return await clientPublicService
      .post(`/core/management/benefit-type`, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

export const updateBenefitType = async ({ token, id, payload }) => {
  try {
    const encodedId = encodeId(id)

    return await clientPublicService
      .put(`/core/management/benefit-type/${encodedId}`, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

export const deleteBenefitType = async ({ token, id }) => {
  try {
    const encodedId = encodeId(id)

    return await clientPublicService
      .delete(`/core/management/benefit-type/${encodedId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}
